export default "__VITE_ASSET__Yx6R0cbo__"